module.exports = __webpack_public_path__ + "img/chicken-breasts-with-savory-peach-glaze.8aeb33ef.jpg";